














































import Vue from 'vue';
import CtrlDialog from '@/components/common/control/CtrlDialog.vue';
// #897425 OutStatus対応
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
// #897425
import axios from '@/plugins/axios';
import { API_SEARCH_SHUKA_AREA_HIMMOKU } from '@/constants/api';
import { BUTTON } from '@/constants/label';
// #897425 OutStatus対応
import { OutStatus } from '@/constants/constants';
// #897425

export default Vue.extend({
  name: 'ListShukaAreaHimmoku',
  // #897425 OutStatus対応
  // components: { CtrlDialog },
  components: { CtrlDialog, CtrlMessageDialog },
  // #897425
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    shukaAreaCd: {
      type: Number,
      required: true,
    },
    gyoshuCd: {   // #886580
      type: Number,
      required: true,
    },
    initialDataSearch: {
      type: Boolean,
      default: false,
    },
    getShukaAreaHimmoku: {
      type: Function,
    },
  },
  data: () => ({
    BUTTON: BUTTON,
    headers: [
      {
        text: '',
        sortable: false,
        value: 'checked',
        width: 56,
      },
      {
        text: 'コード',
        sortable: true,
        value: 'himmokuCd',
        width: 101,
      },
      {
        text: '品目',
        sortable: true,
        value: 'himmokuRyakuMei',
        width: 457,
      },
      {
        text: '集荷先倉庫',
        sortable: true,
        value: 'shukasakiSokoRyakuMei',
        width: 287,
      },
    ],
    items: [],
    // #897425 OutStatus対応
    wMessage: false,
    wMessageId: '',
    wMessageTextParam: [] as string[],
    // #897425
  }),

  methods: {
    // #897425 OutStatus対応
    // response error の場合の message dialog で OK click
    handleWarnExit() {
      this.wMessage = false;
      this.wMessageId = '';
      this.wMessageTextParam = [];
    },
    // #897425
    callbackOk() {
      const checkedItems = this.items.filter(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (item: any) => item.checked === true
      );
      if (checkedItems.length > 0) {
        this.getShukaAreaHimmoku(checkedItems);
        this.$emit('update:show', false);
      }
    },
  },

  created() {
    this.initialDataSearch &&
      axios
        .get(API_SEARCH_SHUKA_AREA_HIMMOKU, {
          params: {
             shukaAreaCd: this.shukaAreaCd,
             gyoshuCd: this.gyoshuCd,       // #886580
          }, 
        })
        .then((res) => {
          // #897425 OutStatus対応
          if (
            res &&
            res.status == 200 &&
            res.data &&
            res.data.error &&
            res.data.error.outStatus &&
            res.data.error.outStatus != OutStatus.NORMAL
          ) {
            this.wMessageId = res.data.error.messageID;
            this.wMessageTextParam = res.data.error.messageArgs;
            this.wMessage = true;

            // 一覧をクリア
            this.items = [];
            return;
          }
          // #897425
          this.items = res.data.responseData;
        })
        .catch((err) => {
          console.log(err.response);
        });
  },
});
